import React, { PureComponent } from 'react';
import ReactPlayer from 'react-player'

class Interview extends PureComponent {
  render() {
    const { body, video_url } = this.props;
    return (
      <div className="interview">
        <div className="row">
          <div className="col-md-5">
            <div dangerouslySetInnerHTML={{ __html: body }}/>
          </div>
          <div className="col-md-7">
            <ReactPlayer
              url={video_url}
              playing={false}
              controls={true}
              loop={false}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Interview;



// WEBPACK FOOTER //
// ./src/components/interview/index.js